module.exports = __webpack_public_path__ + "img/person_studying.6212704e.png";